module.exports = __webpack_public_path__ + "static/media/contentExample2.94e87900.png";